import { createAction, props } from '@ngrx/store';
import { TravelStatusUpdateRequest } from '../travel-status-update.types';

/**
 * Travel-status-update actions. This slice owns no state of its own — it only orchestrates writes
 * to the notification and timesheet slices and the OData save — so there is no reducer here, and
 * these actions only ever flow through `TravelStatusUpdateEffects`.
 */

/** Starts the submit pipeline for `request`. */
export const submitTravelStatusRequested = createAction(
    '[TravelStatusUpdate] Submit requested',
    props<{ request: TravelStatusUpdateRequest; correlationId: string }>(),
);

/** Resolves the caller's observable with the outcome of a successful submit. */
export const travelStatusSubmitSucceeded = createAction(
    '[TravelStatusUpdate] Submit succeeded',
    props<{ correlationId: string }>(),
);

/** Errors the caller's observable, carrying the message the pipeline threw. */
export const travelStatusSubmitFailed = createAction(
    '[TravelStatusUpdate] Submit failed',
    props<{ correlationId: string; error: string }>(),
);

/**
 * Completes the caller's observable without emitting — reproduces the legacy OData-failure path,
 * where `odataSaveTravelStatusUpdate` caught the error, raised an app notification and returned
 * `EMPTY`, so `submitStatus` completed silently and the component's `concatMap` never ran. Without
 * a dedicated outcome that becomes either a false success or a false error. Same mechanism as
 * `submitConfirmationAborted`.
 */
export const travelStatusSubmitAborted = createAction(
    '[TravelStatusUpdate] Submit aborted',
    props<{ correlationId: string }>(),
);
